import { defineMessage } from 'services/localization';

export const messages = {
    approvalMatrixForTheStep: defineMessage('approval_matrix_for_the_step_step'),
    reviewAndCodingMatrix: defineMessage('review_and_coding_matrix'),
    requesterMatrix: defineMessage('requester_matrix'),
    invalidConditions: defineMessage('please_ensure_that_all_set_conditions_are_valid'),
    invalidAutoApprovalConditions: defineMessage('please_specify_the_autoapproval_rule'),
    autoApprovalMatrix: defineMessage('autoapproval_matrix'),
    editingMatrix: defineMessage('editing_matrix'),
};
